import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';

import { tmsSettingsApiSchema } from '../../models';
import { logger } from '../../utils/logger';

export type GetTMSSettingsRequestParams = {
  customerKey: number;
};

const masterSettingsApi = fetcher.extend(() => ({
  prefixUrl: `${API.MASTER_SETTINGS}`,
}));

export const fetchTMSSettings = async (
  params: GetTMSSettingsRequestParams,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await masterSettingsApi.get('GetTMSSettings', { searchParams: params, signal }).json(tmsSettingsApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn(
        'Validation error on TMS settings response',
        (error as ValiError<typeof tmsSettingsApiSchema>).issues,
      );
    }

    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
